export default __webpack_public_path__ + "static/media/previous.33785ae4.svg";